<template>
  <section class="app-container">
    <van-notice-bar mode="closeable">
      温馨提示：扫描二维码进入界面稍作等待后，闸机将会开启，请您有序驶入停车场。
      出场时扫描门口二维码支付停车费用即可正常离场，祝您一路顺风。
    </van-notice-bar>
    <div class="banner_content">
      <div class="result_title">{{ result_title }}</div>
      <van-image width="90%" height="auto" fit="contain" :src="banner_image" class="banner_image">
        <template v-slot:loading>
          <van-loading type="spinner" size="100" />
        </template>
      </van-image>
    </div>
    <!-- <div class="btn_box">
      <van-button @click="onSubmit" :disabled="isDisabled" size="large" class="blue-btn">立即开闸</van-button>
    </div> -->
  </section>
</template>

<script>
import { NoticeBar } from 'vant';
import banner from '@/assets/payment-related/unlicensed.png'
import { getUrlParam } from '@/utils'
import { unlicensedAdmission } from '@/api/user'
import { mapGetters } from 'vuex'
export default {
  name: 'Unlicensed',
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token'])
  },
  components: {
    [NoticeBar.name]: NoticeBar
  },
  data () {
    return {
      isDisabled: false,
      result_title: "欢迎驶入",
      banner_image: banner
    }
  },
  mounted () {
    this.onSubmit()
  },
  methods: {
    onSubmit () {
      let _this = this;
      let getCodeLoading = _this.$toast.loading('正在加载...')
      let params = {
        mac: getUrlParam('mac') || '',
        largeCar: false,
        time: getUrlParam('time') || '',
      }
      unlicensedAdmission(params).then(() => {
        _this.$toast.success('入场成功');
        _this.isDisabled = true
        getCodeLoading.clear()
      }).catch(error => {
        _this.$toast('入场失败 请联系车辆管理员')
        getCodeLoading.clear()
        _this.$notify({
          type: 'danger',
          message: error
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  height: 100vh;

  .banner_content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    height: calc(100vh - 300px);
    text-align: center;

    .banner_image {
      width: 120px;
      height: auto;
      margin: 0 auto 20px;
    }

    .result_title {
      height: 40px;
      line-height: 40px;
      font-size: 22px;
    }
  }

  .button_box {
    padding: 0 10px 0;
  }
  .btn_box {
    padding: 0 15px;
  }
}
</style>